/**
 * Injeta a seção Video Testimonials da home na PDP (mesmos vídeos, um só lugar para configurar).
 */
(function () {
  const mount = document.querySelector('[data-mercadao-home-videos]');
  if (!mount) return;

  if (!window.location.pathname.includes('/products/')) {
    mount.remove();
    return;
  }

  if (document.querySelector('.video-testimonials')) {
    mount.remove();
    return;
  }

  const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const DEFAULT_SECTION_KEY = 'template--20872749056194__video_testimonials';

  const loadStylesheet = () =>
    new Promise((resolve) => {
      const href = mount.dataset.carouselCss || '';
      if (!href) {
        resolve();
        return;
      }
      if (document.querySelector(`link[href="${href}"]`)) {
        resolve();
        return;
      }
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = () => resolve();
      link.onerror = () => resolve();
      document.head.appendChild(link);
    });

  const loadSwatches = () =>
    new Promise((resolve) => {
      const src = mount.dataset.swatchesSrc || '';
      if (!src) {
        resolve();
        return;
      }
      if (document.querySelector(`script[src="${src}"]`)) {
        resolve();
        return;
      }
      const s = document.createElement('script');
      s.src = src;
      s.defer = true;
      s.onload = () => resolve();
      s.onerror = () => resolve();
      document.head.appendChild(s);
    });

  const loadScript = () =>
    new Promise((resolve) => {
      if (customElements.get('video-testimonials-carousel')) {
        resolve();
        return;
      }
      const existing = document.querySelector('script[src*="video-testimonials-carousel"]');
      if (existing) {
        if (existing.dataset.loaded === 'true') {
          resolve();
          return;
        }
        existing.addEventListener('load', () => resolve(), { once: true });
        existing.addEventListener('error', () => resolve(), { once: true });
        return;
      }
      const s = document.createElement('script');
      s.src = mount.dataset.carouselSrc || '';
      if (!s.src) {
        resolve();
        return;
      }
      s.defer = true;
      s.onload = () => {
        s.dataset.loaded = 'true';
        resolve();
      };
      s.onerror = () => resolve();
      document.head.appendChild(s);
    });

  const resolveSectionKey = async () => {
    const hinted = (mount.dataset.sectionKey || '').trim();
    if (hinted.includes('template--') && hinted.includes('__video_testimonials')) {
      return hinted;
    }
    try {
      const res = await fetch(`${root}`, { credentials: 'same-origin' });
      const html = await res.text();
      const match = html.match(/shopify-section-(template--[^"'\\s]+__video_testimonials)/);
      if (match) return match[1];
    } catch (_) {
      /* ignore */
    }
    return hinted || DEFAULT_SECTION_KEY;
  };

  const shouldPreserveScroll = () => {
    const hash = (window.location.hash || '').replace('#', '');
    return hash === 'md-pdp-ficha' || hash === 'md-pdp-descricao' || hash === 'md-pdp-detalhes';
  };

  const lockPageScroll = (savedY) => {
    if (shouldPreserveScroll()) return;
    window.scrollTo({ top: savedY, left: 0, behavior: 'instant' });
  };

  const showMountError = () => {
    mount.classList.add('md-pdp__videos-mount--error');
    mount.setAttribute('aria-busy', 'false');
    mount.innerHTML =
      '<p class="md-pdp__videos-mount-msg">Não foi possível carregar os vídeos. Abra a home no editor do tema → <strong>Video Testimonials</strong> e vincule os arquivos de vídeo de novo.</p>';
  };

  const afterInject = (sectionEl) => {
    const savedY = shouldPreserveScroll() ? window.scrollY : 0;

    sectionEl.querySelector('.video-testimonials__wrap')?.remove();
    mount.remove();

    const carousels = sectionEl.querySelectorAll('video-testimonials-carousel');
    carousels.forEach((el) => {
      if (typeof customElements.upgrade === 'function') customElements.upgrade(el);
    });

    const refresh = () => window.MercadaoVideoCarousel?.refresh(sectionEl);

    refresh();
    [100, 300, 600, 1200, 2500].forEach((ms) => window.setTimeout(refresh, ms));

    sectionEl.querySelectorAll('video').forEach((video) => {
      video.addEventListener('loadeddata', refresh, { once: true });
      video.addEventListener('canplay', refresh, { once: true });
    });

    lockPageScroll(savedY);
    requestAnimationFrame(() => lockPageScroll(savedY));
    [50, 150, 350, 700, 1200].forEach((ms) => {
      window.setTimeout(() => lockPageScroll(savedY), ms);
    });
  };

  const insertSection = (sectionEl) => {
    const anchor =
      document.querySelector('.md-pdp__content') ||
      document.querySelector('.section-mercadao-product article') ||
      mount.parentElement;

    if (anchor) {
      anchor.insertAdjacentElement('afterend', sectionEl);
    } else {
      mount.replaceWith(sectionEl);
    }
  };

  const loadVideos = async (attempt = 0) => {
    try {
      await Promise.all([loadStylesheet(), loadSwatches()]);
      await loadScript();
      const sectionKey = await resolveSectionKey();
      const res = await fetch(`${root}?sections=${encodeURIComponent(sectionKey)}`, {
        credentials: 'same-origin',
      });
      if (!res.ok) throw new Error(`sections HTTP ${res.status}`);
      const sections = await res.json();
      const html = sections[sectionKey];
      if (!html || String(html).trim().length < 50) throw new Error('empty section');

      const wrapper = document.createElement('div');
      wrapper.innerHTML = html;
      const sectionEl =
        wrapper.querySelector('.shopify-section, [id^="shopify-section-"]') ||
        wrapper.firstElementChild;
      if (!sectionEl) throw new Error('no section element');

      insertSection(sectionEl);
      afterInject(sectionEl);
    } catch (_) {
      if (attempt < 3) {
        window.setTimeout(() => loadVideos(attempt + 1), 600 + attempt * 400);
        return;
      }
      showMountError();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => loadVideos());
  } else {
    loadVideos();
  }
})();
